// extracted by mini-css-extract-plugin
export default {"priceItemList":"PriceItemList_priceItemList__vTI9E","priceListItem":"PriceItemList_priceListItem__gHigA"};